module.exports = __webpack_public_path__ + "img/subscription-settings.dbf349ef.svg";